import { ReactNode } from 'react';
import { animated, useSpring } from 'react-spring';
import { useMeasure } from 'react-use';
import styled from 'styled-components';

import { unitMapping } from 'lib/style';

const Wrapper = styled(animated.div)`
  position: relative;
  overflow: hidden;
`;
const Gap = styled.div<{ $gap: keyof typeof unitMapping }>`
  display: flex;
  height: calc(var(--unit) * ${({ $gap }) => $gap});
`;

type Props = {
  open?: boolean;
  children: ReactNode;
  className?: string;
  gap?: keyof typeof unitMapping;
};
export const Collapse = ({ open, children, className, gap = 2 }: Props) => {
  const [measurementDiv, { height }] = useMeasure<HTMLDivElement>();

  const springArg = {
    to: {
      opacity: open ? 1 : 0,
      height: open ? height : 0,
    },
    config: {
      duration: 100,
    },
  };

  return (
    <Wrapper className={className} style={useSpring(springArg)}>
      <div ref={measurementDiv}>
        {!!gap && <Gap $gap={gap} />}
        {children}
      </div>
    </Wrapper>
  );
};
